import { render, staticRenderFns } from "./ActivityGallery.vue?vue&type=template&id=2245548f&scoped=true"
import script from "./ActivityGallery.vue?vue&type=script&lang=js"
export * from "./ActivityGallery.vue?vue&type=script&lang=js"
import style0 from "./ActivityGallery.vue?vue&type=style&index=0&id=2245548f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2245548f",
  null
  
)

export default component.exports